import { BranchCategoryListPage } from '@/features/branch-category/pages/BranchCategoryListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/branch-category/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["branch_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BranchCategoryListPage,
})
